import { render, staticRenderFns } from "./HighEndTradeMustKnow.vue?vue&type=template&id=c4a185ea&scoped=true&"
import script from "./HighEndTradeMustKnow.vue?vue&type=script&lang=js&"
export * from "./HighEndTradeMustKnow.vue?vue&type=script&lang=js&"
import style0 from "./HighEndTradeMustKnow.vue?vue&type=style&index=0&id=c4a185ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a185ea",
  null
  
)

export default component.exports